import { useContext, useEffect } from 'react';

import PageContext from '@/Providers/PageContextProvider/PageContext';
import {
  getThemeByPreference,
  subscribeToSystemTheme,
  systemThemePreference,
} from '@/shared/utils/theme';

export { getThemeBySystemConfiguration } from '@/shared/utils/theme';

export default function useTheme() {
  const { isPreview, themePreference, setTheme } = useContext(PageContext);

  useEffect(() => {
    if (isPreview) {
      return;
    }

    const changeTheme = () => {
      setTheme(getThemeByPreference(themePreference));
    };

    changeTheme();

    if (themePreference !== systemThemePreference) {
      return;
    }

    return subscribeToSystemTheme(changeTheme);
  }, [isPreview, setTheme, themePreference]);
}
